const ROOTS = {
    // AUTH: '/auth',
    AUTH: "",
    // AUTH_DEMO: '/auth-demo',
    DASHBOARD: "/dashboard"
};

// ----------------------------------------------------------------------

export const paths = {
    shipsavingTerms: "https://www.shipsaving.com/en/terms",
    comingSoon: "/coming-soon",
    //
    maintenance: "/maintenance",
    //
    page500: "/500",
    page404: "/404",
    page403: "/403",
    page402: "/402",
    //
    // AUTH
    auth: {
        login: `${ROOTS.AUTH}/login`,
        register: `${ROOTS.AUTH}/signup`,
        forgot_password: `${ROOTS.AUTH}/forgot_password`,
        reset_password: `${ROOTS.AUTH}/reset_password`,
        verified: `${ROOTS.AUTH}/verified_email`
    },
    //
    onboarding: "/onboarding",
    // DASHBOARD
    dashboard: {
        root: ROOTS.DASHBOARD,
        //
        home: `/home`,
        //
        tasks: `/tasks`,
        //
        transaction: `/transactions`,
        //
        billing: {
            root: `/billing`,
            rechargeHistory: `/billing/recharge-history`
        },
        //
        api: {
            root: `/api`,
            //
            key: {
                root: `/api/key`
            },
            webhook: {
                root: `/api/webhooks`
            }
        },
        shipments: {
            root: `/shipping`,
            //
            label: {
                root: `/shipping/shipments`
            },
            pickup: {
                root: `/shipping/pickups`
            },
            scanForm: {
                root: `/shipping/scan_form`
            }
        },
        settings: {
            root: `/settings`,
            //
            profile: {
                root: `/settings/profile`
            },
            transaction_history: {
                root: `/settings/transaction_history`
            },
            carriers: {
                root: `/settings/carriers`
            }
        },
        //
        blank: `${ROOTS.DASHBOARD}/blank`
    },
    //
    preview: `/label`,
    //
    // External
    external: {
        mainSite: "https://www.shipsaving.com",
        tutorials: (index) => `https://www.youtube.com/embed/?list=PLu8E_4Z-kU0iKdqv7VjRUQF72c2ZAhOKq&index=${index}&autoplay=1`,
        whatIsUSPSScanForm: "https://www.shipsaving.com/blog/what-is-the-usps-scan-form",
        shipsavingFeatures: "https://www.shipsaving.com/en/features",
        shipsavingTerms: "https://www.shipsaving.com/en/terms",
        shipsavingPartners: "https://www.shipsaving.com/en/partners",
        upsGuide: "https://www.canva.com/design/DAEe23d4zL0/dX-urCesPJjNKd2qrh6lgQ/view?utm_content=DAEe23d4zL0&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton",
        mps: "https://www.shipsaving.com/blog/what-is-multi-piece-shipment",
        uspsScanForm: "https://www.shipsaving.com/blog/5-reasons-why-you-must-use-usps-scan-form",
        uspsPub52: "https://pe.usps.com/text/pub52/welcome.htm",
        uspsHazmatShippingSafety: "https://www.uspsdelivers.com/hazmat-shipping-safety/",
        upsCarries: "https://www.shipsaving.com/carries/ups",
        shipsavingBlogShippingGuideGeneralDangerousAndProhibitedItems: "https://www.shipsaving.com/blog/shipping-guide-general-dangerous-and-prohibited-items",
        fedexAgreement: "https://cdn.shipsaving.com/assets/file/fedex/EULA(DistributionAgreement).pdf",
        orderTemplate: "https://cdn.shipsaving.com/assets/file/template/ShipSaving_Order_Template.csv",
        withdrawForm: "https://cdn.shipsaving.com/assets/file/template/withdrawal_request_form.pdf",
        upsFindLocations: "https://www.ups.com/dropoff?loc=en_us",
        fedexDiscountedRates: "https://www.shipsaving.com/blog/exciting-news-discounted-fedex-rates-now-available-with-shipsaving",
        apiDoc: "https://docs.shipsaving.com/v2"
    }
};
